import { render, staticRenderFns } from "./ClientMedicineInstructionsItem.vue?vue&type=template&id=01e30464&scoped=true"
import script from "./ClientMedicineInstructionsItem.vue?vue&type=script&lang=js"
export * from "./ClientMedicineInstructionsItem.vue?vue&type=script&lang=js"
import style0 from "./ClientMedicineInstructionsItem.vue?vue&type=style&index=0&id=01e30464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e30464",
  null
  
)

export default component.exports